import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Modal } from 'react-bootstrap';
import LoadingComponent from '../../../common/LoadingComponent';
import { deleteSegmentRequested } from '../actions';
import { getSegmentDeleteLoading } from '../selectors';
import './styles.scss';

function SegmentDelete({ show, loading, onClose, segmentId, deleteSegment }) {
    useEffect(() => {
        if (!loading) {
            onClose();
        }
    }, [loading]);

    const loader = <LoadingComponent isLoading={loading} />;
    return (
        <div>
            <Modal
                onHide={() => {
                    onClose();
                }}
                backdrop="static"
                show={show}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className="segment-delete-modal"
                centered={true}
                animation={true}
            >
                {loading && loader}
                <label>Are you sure you want to delete this segment?</label>
                <div className="footer">
                    <button
                        onClick={() => deleteSegment(segmentId)}
                        className="save-btn"
                    >
                        Delete
                    </button>
                    <button onClick={onClose} className="cancel-btn">
                        Cancel
                    </button>
                </div>
            </Modal>
        </div>
    );
}

SegmentDelete.propTypes = {
    show: PropTypes.bool,
    segmentId: PropTypes.string,
    loading: PropTypes.bool,
    onClose: PropTypes.func,
    deleteSegment: PropTypes.func,
};

SegmentDelete.defaultProps = {
    show: false,
    segmentId: null,
    loading: false,
};

const mapStateToProps = (state) => {
    return {
        loading: getSegmentDeleteLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteSegment: (segmentId) =>
            dispatch(deleteSegmentRequested(segmentId)),
    };
};

const ConnectedSegmentDelete = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SegmentDelete);

export default ConnectedSegmentDelete;
